import { routes2 } from '@linqpal/models'

export const getUserProjects = async () => {
  try {
    const { items: projects } = await routes2.project.findAll({
      page: 1,
      pageSize: 60,
    })

    return projects
  } catch (err) {
    console.error(err)
    return null
  }
}
